"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogSource = void 0;
var ILogMessage_1 = require("./ILogMessage");
var IPlayerError_1 = require("./IPlayerError");
var PlayerLog_1 = require("./PlayerLog");
var LogSource = (function () {
    function LogSource(packageName, version) {
        this.packageName = packageName;
        this.version = version;
    }
    LogSource.fromPackage = function (packageJson) {
        return new LogSource(packageJson.name, packageJson.version);
    };
    LogSource.prototype.detectDuplicateError = function (candidate) {
        var _a, _b;
        if (!candidate || !this.lastError)
            return false;
        if (this.lastError.message != candidate.message)
            return false;
        if (candidate instanceof IPlayerError_1.PlayerError &&
            this.lastError instanceof IPlayerError_1.PlayerError) {
            if (candidate.engine != this.lastError.engine)
                return false;
            if (candidate.code != this.lastError.code)
                return false;
            if (candidate.nativeCode != this.lastError.nativeCode)
                return false;
            if (((_a = candidate.source) === null || _a === void 0 ? void 0 : _a.url) != ((_b = this.lastError.source) === null || _b === void 0 ? void 0 : _b.url))
                return false;
        }
        return true;
    };
    LogSource.prototype.log = function (level, message, optionalParams) {
        var error;
        var extraParams = optionalParams;
        if (optionalParams.length == 1 && optionalParams[0] instanceof Error) {
            error = optionalParams[0];
            extraParams = undefined;
        }
        if (this.detectDuplicateError(error))
            return;
        PlayerLog_1.PlayerLog.log({
            source: {
                packageName: this.packageName,
                version: this.version,
            },
            level: level,
            message: message,
            extraParams: extraParams,
            error: error,
        });
    };
    LogSource.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.log(ILogMessage_1.LogLevel.DEBUG, message, optionalParams);
    };
    LogSource.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.log(ILogMessage_1.LogLevel.INFO, message, optionalParams);
    };
    LogSource.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.log(ILogMessage_1.LogLevel.WARNING, message, optionalParams);
    };
    LogSource.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.log(ILogMessage_1.LogLevel.ERROR, message, optionalParams);
    };
    return LogSource;
}());
exports.LogSource = LogSource;
//# sourceMappingURL=LogSource.js.map